<template>
    <Button :icon="attrs.icon" type="primary" @click="handleClick" :loading="isSubmit" v-if="isDisplay">
        {{attrs.title}}
    </Button>
</template>
<script>
    import CompEventMixin from '@/utils/compEvent.mixin'
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    /**
     * 处理数据提交的按钮
     */
    export default {
        name: 'LySubmitButton',
        mixins: [CompEventMixin, CompDisplayMixin],
        props: {
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        data () {
            return {
                isSubmit: false, // 标识，是否是在提交
            }
        },
        created () {
            // 监听页面数据的传递
            this.$eventHub.$on(this.$events.SUBMIT_METHOD_UPDATE, this.handleSubmitMethodUpdate)
        },
        methods: {
            /**
             * 提交事件的处理
             */
            handleClick () {
                // 发送要提交数据的事件
                this.$eventHub.$emit(this.$events.SUBMIT_DATA, {
                    api: this.attrs.api, // 提交的API
                    method: this.attrs.method, // 提交的方式
                    mark: this.attrs.mark, // 以page中那个字段的对象 取参数对象
                    route: this.attrs.route || '' ,// 提交过后跳转的页面
                    idname: this.attrs.idname || '' // 路由上的捆绑数据
                })
            },
            /**
             * 监听提交行为的改变
             */
            handleSubmitMethodUpdate (data) {
                Object.assign(this.attrs, data)
            }
        },
        destroyed () {
            // 销毁事件的监听
            this.$eventHub.$off(this.$events.SUBMIT_METHOD_UPDATE, this.handleSubmitMethodUpdate)
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/submit-button/src/index.vue